import { action } from "typesafe-actions";
import { LanguageTypes, LanguageActionTypes } from "./types";
import { AppDispatch } from "index";

export function setLanguage(type: LanguageTypes) {
  return (dispatch: AppDispatch) => {
    dispatch(action(LanguageActionTypes.SET_LANGUAGE, type));
  };
}
